var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultOrgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3946 20.75H4.12995C2.21651 20.75 0.663574 22.299 0.663574 24.2V65.6C0.663574 67.5079 2.21651 69.05 4.12995 69.05H28.3946C30.308 69.05 31.861 67.5079 31.861 65.6V24.2C31.861 22.2956 30.308 20.75 28.3946 20.75ZM24.9282 62.15H21.4618V55.25H11.0627V62.15H7.59633V48.35H14.5291V41.45H7.59633V38H17.9955V31.1H7.59633V27.65H24.9282V62.15Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.525 0.0507812H42.2603C40.3469 0.0507812 38.7939 1.59983 38.7939 3.50078V65.6008C38.7939 67.5086 40.3469 69.0508 42.2603 69.0508H66.525C68.4384 69.0508 69.9913 67.5086 69.9913 65.6008V3.50078C69.9913 1.59638 68.4384 0.0507812 66.525 0.0507812ZM63.0586 62.1508H59.5922V55.2508H49.1931V62.1508H45.7267V38.0008H52.6595V31.1008H45.7267V27.6508H56.1258V20.7508H45.7267V17.3008H59.5922V10.4008H45.7267V6.95078H63.0586V62.1508Z",
    fill: "#7E7E7E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultOrgLogo);
export default __webpack_public_path__ + "static/media/DefaultOrgLogo.d9393c5e7e072c0d4c85909afa8c4361.svg";
export { ForwardRef as ReactComponent };